export default "__VITE_ASSET__CvChXtqe__ 800w, __VITE_ASSET__BJ_Odo7$__ 1200w, __VITE_ASSET__BplPJICR__ 1774w";